<template>
  <Panel
    :class="'time-frame-panel'"
    class="time-frame-section"
    :variant="['30-12-paddings', 'default', 'rounded']"
  >
    <Subheader
      :text="$$t('Time Frames')"
      class="mb-5 tournament-time-subheader"
    />
    <div class="tournament-start">
      <TournamentTimeStepSetting
        :time-frames="startTournamentTimeFrames"
        class="mb-5"
      />
    </div>
    <div>
      <TournamentTimeStepSetting
        :time-frames="registrationTimeFrames"
        class="registration-start"
      />
    </div>
    <div class="row mt-5">
      <div class="col auto-process">
        <SettingsAutoprocessing />
      </div>
    </div>
  </Panel>
</template>

<script>
import { translate } from '@/mixins/translate';

import Panel from '@/components/atoms/Panel';
import Subheader from '@/components/atoms/Subheader';
import TournamentTimeStepSetting from '@/views/tournaments/management/singleTournament/components/SettingsTimeFrameInput';
import SettingsAutoprocessing from '@/views/tournaments/management/singleTournament/components/SettingsAutoprocessing';
export default {
  name: 'SectionSchedule',
  components: {
    Panel,
    Subheader,
    TournamentTimeStepSetting,
    SettingsAutoprocessing,
  },
  mixins: [translate('_web_tournament_settings')],
  computed: {
    startTournamentTimeFrames() {
      return ['tournament_start'];
    },
    registrationTimeFrames() {
      return ['registration_start', 'registration_end'];
    },
  },
};
</script>
<style lang="scss">
.time-frame-section {
  .subheader {
    .hera-text-block {
      position: relative;

      &:after {
        @include required-asterisk();
        margin-top: -8px;
      }
    }
  }
}
.time-frame-panel {
  padding-top: 20px;
}

.tournament-time-subheader span {
  font-weight: 700;
  font-size: $hr-heading-5 !important;
}

.tournament-start :nth-child(1) label {
  padding-bottom: 20px;
  font-weight: 600;
  font-size: $hr-text-small !important;
}

.tournament-start :nth-child(2) input {
  background-color: $hr-bg-header;
  margin-bottom: 16px;
}

.date-time-wrapper {
  align-items: flex-end !important;
}

.registration-start :nth-child(1) label {
  padding-bottom: 20px;
  font-weight: 600;
  font-size: $hr-text-small !important;
}

.registration-start :nth-child(2) input {
  background-color: $hr-bg-header;
  margin-bottom: 16px;
}

.auto-process :nth-child(1) label {
  font-size: $hr-text-small !important;
  font-weight: 600;
  margin-bottom: 20px;
}

.auto-process :nth-child(2) span {
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.auto-process :nth-child(2) div {
  margin-bottom: 20px !important;
  color: $hr-text-muted;
}

.auto-process :nth-child(3) label {
  background-color: $hr-bg-header;
}

.auto-process :nth-child(3) div {
  margin-bottom: 10px;
}
</style>
